import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const appStoreState = namespace('appStore');

@Component
export default class PopupAlertPinComponent extends Vue {
  @appStoreState.Getter
  public getIsShowAlertPinBriefing!: boolean;

  @appStoreState.Mutation
  public setIsShowAlertPinBriefing!: (newVal: boolean) => void;

  handleCloseModal() {
    this.setIsShowAlertPinBriefing(false);
  }

  @Watch('$route')
  onChange() {
    this.handleCloseModal();
  }
}
